import { env } from '../env/env';
export const cardsConfig = {
    CARDS_UI_URL: env.getString('REACT_APP_CARDS_UI_URL') || 'https://uat-card.c2fo.com',
    CARDS_STATUS_API_URL: env.getString('REACT_APP_CARDS_STATUS_API_URL') || '',
    CARDS_MARKETING_SIGNUP_URL: 'https://get.c2fo.com/signup',
};
//# sourceMappingURL=cardsConfig.js.map